import _ from 'lodash';
import { staticChartKeys } from '../../../constants/static-chart-keys';
import { ChartResponse, DataKPI } from '../../../redux/config/chart-data';

const filteredKeys = <T extends DataKPI | ChartResponse>(data: T[]) =>
  _.uniq(data.flatMap((object) => Object.keys(object)).filter((key) => !staticChartKeys.includes(key)));

export default filteredKeys;
